<template>
  <OffcanvasComponent
    :id="`offcanvas_views`"
    :title="title"
    :showClose="store.history.length > 1"
    @offcanvasClosed="offcanvasClosed"
    @offcanvasDismissed="closeOffCanvas"
  >
    <div class="offcanvas-body">
      <component :is="View" v-bind="viewProps" />
    </div>
    <!-- rodapé fixo opcional: a view manda as ações com <Teleport defer to="#offcanvas_views_footer"> -->
    <div class="offcanvas-footer" id="offcanvas_views_footer"></div>
  </OffcanvasComponent>
</template>

<script setup lang="ts">
import { computed, type Component } from "vue";
import { useOffcanvasStore } from "@/store/useOffcanvasStore";
import { toggleOffcanvas } from "@/utils/Helper";
import { closeOffCanvas, OffcanvasViewKey, OffcanvasViewsConfig, Views } from "./OffcanvasViewsConfig";

const store = useOffcanvasStore();

const View = computed<Component | null>(
  () => Views[store.config?.path as OffcanvasViewKey] || null,
);
const viewProps = computed(() => store.config?.props ?? null);
// título da configuração atual: um painel salvo antes (localStorage) não mostra um título antigo.
// Título que depende do conteúdo ("Depoimentos de …") vai em props.title.
const title = computed(
  () =>
    store.config?.props?.title ??
    OffcanvasViewsConfig[store.config?.path as OffcanvasViewKey]?.title ??
    store.config?.title ??
    "",
);

function offcanvasClosed() {
  if (store.history.length === 1) {
    toggleOffcanvas("offcanvas_views");
    setTimeout(() => {
      store.clear();
    }, 200);
  } else {
    store.popHistory();
  }
}
</script>
